// src/config/wsZeroDayConfig.js (NEW FILE)

/**
 * Defines the message types and STOMP topics for the Zero-Day Method module.
 */

export const WS_ZERO_DAY_TYPES = {
    // --- Client -> Server ---
    // CONNECT_SERVER: 'ZERO_DAY_CONNECT_SERVER',      // Not primary focus, ServerInfoCard handles connection
    // DISCONNECT_SERVER: 'ZERO_DAY_DISCONNECT_SERVER',// Optional
    EXECUTE_METHOD: 'ZERO_DAY_EXECUTE_METHOD',     // Payload: { ip: string, vectorId: number (optional), options: { aiConfig: object } }
    // SCAN_ONLY is deprecated for AI sim
    STOP_OPERATION: 'ZERO_DAY_STOP_OPERATION',      // Payload: { ip: string } (To stop analysis/RCON)
    GET_STATE: 'ZERO_DAY_GET_STATE',            // Payload: {}
    RCON_COMMAND: 'ZERO_DAY_RCON_COMMAND',       // Payload: { command: string }

    // --- Server -> Client (User Queue) ---
    // Status/General Updates (/user/queue/zero-day/status)
    CONNECTION_STATUS: 'ZERO_DAY_CONNECTION_STATUS', // From ServerInfoCard usually
    // SCAN_STARTED, SCAN_COMPLETED deprecated
    EXECUTION_STARTED: 'ZERO_DAY_EXECUTION_STARTED',  // Payload: { message: string, initialPlan?: object } -> message only for now
    EXECUTION_COMPLETED: 'ZERO_DAY_EXECUTION_COMPLETED',// Payload: { status: 'completed', message: string, rconAccessGranted: boolean, reportData: object }
    CURRENT_STATE: 'ZERO_DAY_CURRENT_STATE',      // Payload: ZeroDayCurrentStateDto (as defined in backend)

    // Progress Updates (/user/queue/zero-day/progress)
    CONSOLE_LINE: 'ZERO_DAY_CONSOLE_LINE',        // Payload: { type: string (WsZeroDayConfig.ConsoleLineType), content: string, progressUpdate?: ZeroDayTaskUpdateDto }
    OPERATION_STATUS: 'ZERO_DAY_OPERATION_STATUS',  // Payload: { message: string } // Generic status updates
    AI_TASK_UPDATE: 'ZERO_DAY_AI_TASK_UPDATE',   // Payload: ZeroDayTaskUpdateDto (structure mirrors AiProgress state)

    // Error Updates (/user/queue/zero-day/error)
    ERROR: 'ZERO_DAY_ERROR',                   // Payload: { message: string, isFatal: boolean, context?: string }
  };
  
  export const WS_ZERO_DAY_TOPICS = {
    // --- Destinations for Client Commands ---
APP_ENDPOINT_BASE: '/zero-day',
    // CONNECT: '/connect', // Not used directly by page
    // DISCONNECT: '/disconnect', // Not used directly by page
    EXECUTE: '/execute',
    // SCAN: '/scan', // Deprecated
    STOP: '/stop',
    GET_STATE: '/get-state',
    RCON_COMMAND: '/rcon-command',
  
    // --- User-Specific Subscription Topics ---
    USER_QUEUE_BASE: '/user/queue/zero-day',
    STATUS: '/status',    // For CONNECTION_STATUS, *_STARTED, *_COMPLETED, CURRENT_STATE
    PROGRESS: '/progress', // For CONSOLE_LINE, OPERATION_STATUS
    ERROR: '/error',      // For ERROR messages
  };
  
  // Helper to build full app destination path
  export const getZeroDayAppEndpoint = (action) => `${WS_ZERO_DAY_TOPICS.APP_ENDPOINT_BASE}${action}`;
  // Helper to build full user subscription topic path
  export const getZeroDayUserQueueTopic = (subTopic) => `${WS_ZERO_DAY_TOPICS.USER_QUEUE_BASE}${subTopic}`;
  
  // Define Console Line Types (reuse from ConsoleModal or define specific ones)
  export const ZERO_DAY_CONSOLE_TYPES = {
      SYSTEM: 'system',
      INFO: 'info',
      SCAN: 'scan',      // Specific scan steps
      FOUND: 'found',    // Vulnerabilities or key findings
      METHOD: 'method',  // Execution steps
      SUCCESS: 'success',
      WARNING: 'warning',
       ERROR: 'error',
       AI_LOG: 'ai_log', // For LLM-like outputs from AI
       RCON_REQUEST: 'rcon_request', // User typed RCON command echo
       RCON_RESPONSE: 'rcon_response', // Simulated RCON server response
  };